/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the LNRPDownloadDto interface.
 */
export function instanceOfLNRPDownloadDto(value) {
    if (!('mediaId' in value) || value['mediaId'] === undefined)
        return false;
    if (!('auth' in value) || value['auth'] === undefined)
        return false;
    return true;
}
export function LNRPDownloadDtoFromJSON(json) {
    return LNRPDownloadDtoFromJSONTyped(json, false);
}
export function LNRPDownloadDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mediaId': json['mediaId'],
        'auth': json['auth'],
    };
}
export function LNRPDownloadDtoToJSON(json) {
    return LNRPDownloadDtoToJSONTyped(json, false);
}
export function LNRPDownloadDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'mediaId': value['mediaId'],
        'auth': value['auth'],
    };
}
